import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gutest-account-notifier',
  templateUrl: './gutest-account-notifier.component.html',
  styleUrls: ['./gutest-account-notifier.component.scss']
})
export class GutestAccountNotifierComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
